module.exports = __webpack_public_path__ + "static/media/reservations-devices.1dc0af89.svg";